export const formatFieldName = (fieldName) => {
  return fieldName
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const generateMockData = (field) => {
  const lowerField = field.toLowerCase();
  if (lowerField.includes("cve")) return "CVE-2025-1234";
  if (lowerField.includes("unique_id")) {
    return "arn:aws:ec2:us-west-2:123456789012:instance/i-0abc123def4567890";
  }
  if (lowerField.includes("entity_type")) return "Server";
  if (lowerField.includes("id")) return "CVE-2025-1234";
  if (lowerField.includes("name") || lowerField.includes("title"))
    return "Sample Name";
  if (lowerField.includes("severity")) return "High";
  if (lowerField.includes("score")) return "7.5";
  if (lowerField.includes("date") || lowerField.includes("time"))
    return "2025-01-01";
  if (lowerField.includes("status")) return "Active";
  if (lowerField.includes("description")) return "Sample description";
  if (lowerField.includes("count")) return "42";
  return "Sample Data";
};
